module.exports = __webpack_public_path__ + "app-static/img/16.3c03a7e9.png";